/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, BigNumberish } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { NFTBlindbox } from "../NFTBlindbox";

export class NFTBlindbox__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    baseSettings: {
      name: string;
      symbol: string;
      payees: string[];
      shares: BigNumberish[];
      typeOfNFT: BigNumberish;
      maxSupply: BigNumberish;
    },
    overrides?: Overrides
  ): Promise<NFTBlindbox> {
    return super.deploy(baseSettings, overrides || {}) as Promise<NFTBlindbox>;
  }
  getDeployTransaction(
    baseSettings: {
      name: string;
      symbol: string;
      payees: string[];
      shares: BigNumberish[];
      typeOfNFT: BigNumberish;
      maxSupply: BigNumberish;
    },
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(baseSettings, overrides || {});
  }
  attach(address: string): NFTBlindbox {
    return super.attach(address) as NFTBlindbox;
  }
  connect(signer: Signer): NFTBlindbox__factory {
    return super.connect(signer) as NFTBlindbox__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): NFTBlindbox {
    return new Contract(address, _abi, signerOrProvider) as NFTBlindbox;
  }
}

const _abi = [
  {
    inputs: [
      {
        components: [
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "string",
            name: "symbol",
            type: "string",
          },
          {
            internalType: "address[]",
            name: "payees",
            type: "address[]",
          },
          {
            internalType: "uint256[]",
            name: "shares",
            type: "uint256[]",
          },
          {
            internalType: "uint32",
            name: "typeOfNFT",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "maxSupply",
            type: "uint32",
          },
        ],
        internalType: "struct BaseSettings",
        name: "baseSettings",
        type: "tuple",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "shares",
        type: "uint256",
      },
    ],
    name: "PayeeAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "PaymentReceived",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "PaymentReleased",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "baseURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "blindboxSettings",
    outputs: [
      {
        internalType: "uint32",
        name: "offsetId",
        type: "uint32",
      },
      {
        internalType: "uint128",
        name: "revealTimestamp",
        type: "uint128",
      },
      {
        internalType: "uint96",
        name: "tokenPrice",
        type: "uint96",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "coverURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "baseURI_",
        type: "string",
      },
      {
        internalType: "uint32",
        name: "maxPurchase_",
        type: "uint32",
      },
      {
        internalType: "uint96",
        name: "tokenPrice_",
        type: "uint96",
      },
      {
        internalType: "uint128",
        name: "startTimestamp_",
        type: "uint128",
      },
      {
        internalType: "uint128",
        name: "revealTimestamp_",
        type: "uint128",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isInit",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "numberOfTokens",
        type: "uint32",
      },
    ],
    name: "mintToken",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "payee",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "account",
        type: "address",
      },
    ],
    name: "release",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "released",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "reserveNum",
        type: "uint32",
      },
    ],
    name: "reserveNFT",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "reveal",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "newBaseURI",
        type: "string",
      },
    ],
    name: "setBaseURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "newCoverURI",
        type: "string",
      },
    ],
    name: "setCoverURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint96",
        name: "newTokenPrice",
        type: "uint96",
      },
    ],
    name: "setTokenPrice",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "settings",
    outputs: [
      {
        internalType: "uint32",
        name: "maxSupply",
        type: "uint32",
      },
      {
        internalType: "uint32",
        name: "totalSupply",
        type: "uint32",
      },
      {
        internalType: "uint32",
        name: "maxPurchase",
        type: "uint32",
      },
      {
        internalType: "uint32",
        name: "typeOfNFT",
        type: "uint32",
      },
      {
        internalType: "uint128",
        name: "startTimestamp",
        type: "uint128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "shares",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recevier",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "specialMint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalReleased",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalShares",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";
